import { required, Edit, SimpleForm, ImageField, TextInput, SelectInput, useRecordContext, FileField } from "react-admin";
import { useFormContext } from "react-hook-form";
import { CustomToolbar } from "../../../utils";
import { adLabel } from "../../../normalize";
import { useWatch } from "react-hook-form";
import TYPE_CONTENT_ENUM from "../enums/type-content-enum";
import React, { useEffect, useRef } from "react";
import CustomFileInput from "../../../components/CustomFileInput";
import FileInputAdsCustom from "../FileInputAdsCustom.styles";
import { useNotify } from "react-admin";

const validateRequired = required();
const selectStyle = { width: "230px", minWidth: "230px" };

const ContentTypeInput = () => {
  const tipoConteudo = useWatch({ name: "typeContent.id" });
  const record = useRecordContext();
  const form = useFormContext();
  const { setValue } = form;
  const initialTypeRef = useRef(null);
  const notify = useNotify();

  useEffect(() => {
    if (!record || !record.typeContent || initialTypeRef.current !== null) return;

    const initial = record.typeContent.id;
    initialTypeRef.current = initial;

    if (record.url) {
      if (initial === TYPE_CONTENT_ENUM.FILE) {
        setValue("urlFile", { src: record.url }, { shouldDirty: false });
      } else if (initial === TYPE_CONTENT_ENUM.URL) {
        setValue("url", record.url, { shouldDirty: false });
      }
    }
  }, [record, setValue]);

  useEffect(() => {
    const initial = initialTypeRef.current;
    if (initial === null) return;
    if (tipoConteudo === initial) return;

    if (tipoConteudo === TYPE_CONTENT_ENUM.URL) {
      setValue("url", "", { shouldDirty: true, shouldTouch: true });
      setValue("urlFile", null, { shouldDirty: true, shouldTouch: true });
    } else if (tipoConteudo === TYPE_CONTENT_ENUM.FILE) {
      setValue("urlFile", null, { shouldDirty: true, shouldTouch: true });
    }
  }, [tipoConteudo, setValue]);

  if (tipoConteudo === TYPE_CONTENT_ENUM.URL) {
    return <TextInput label="URL" source="url" validate={validateRequired} resettable />;
  }

  if (tipoConteudo === TYPE_CONTENT_ENUM.FILE) {
    return (
      <FileInputAdsCustom>
      <CustomFileInput
        source="urlFile"
        label="Arquivo"
        accept="application/pdf,image/jpeg,image/png"
        validate={validateRequired}
        uploadText="Arraste um arquivo para upload ou clique para selecionar"
        formatText="Formato aceito: PDF, JPG, PNG"
        options={{
          onDropRejected: () => notify("Arquivo inválido. Apenas arquivos PDF, JPG e PNG são aceitos.", { type: "error" })
        }}
      >
        <FileField source="src" title="title" />
      </CustomFileInput>
      </FileInputAdsCustom>
    );
  }
  return null;
};

const AdEdit = (props) => {
  const notify = useNotify();
  return (
<Edit title="Editar Anúncio" {...props}>
  <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
    <TextInput label="Título" source="title" validate={validateRequired} resettable />
    <TextInput label="Descrição" source="description" validate={validateRequired} resettable />
    <TextInput placeholder="Limite: 20 caracteres" label="Botão Personalizado" source="label" normalize={adLabel} resettable />
    <SelectInput 
        label="Tipo de Conteúdo"
        style={selectStyle}
        source="typeContent.id"
        validate={validateRequired}
        choices={[
          { id: TYPE_CONTENT_ENUM.URL, name: 'URL' },
          { id: TYPE_CONTENT_ENUM.FILE, name: 'Upload de Arquivo' }
        ]}
      />
    <ContentTypeInput />
    <FileInputAdsCustom>
      <CustomFileInput 
        source="icon" 
        label="Imagem" 
        accept="image/*"
        uploadText="Arraste uma imagem para upload ou clique para selecionar"
        formatText="Formato aceito: JPG, PNG"
        options={{
          onDropRejected: () => notify("Arquivo inválido. Apenas arquivos JPG e PNG são aceitos.", { type: "error" })
        }}
      >
        <ImageField source="src" title="title"  />
      </CustomFileInput>
    </FileInputAdsCustom>
  </SimpleForm>
  </Edit>
);
};

export default AdEdit;